import React, { useState } from "react";
import { useAuth } from "@/lib/auth";
import { Navigate } from "react-router-dom";
import { Broadcast } from "@phosphor-icons/react";

export default function Login() {
  const { user, login, error } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user && user !== false) return <Navigate to="/" />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    await login(email, password);
    setLoading(false);
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex bg-[#0A0A0A] text-white relative overflow-hidden">
        <div className="absolute inset-0 noise opacity-40" />
        <div className="relative z-10 p-12 flex flex-col justify-between w-full">
          <div className="flex items-center gap-2">
            <Broadcast size={28} weight="bold" />
            <span className="font-heading font-black text-xl">AppRadar</span>
          </div>
          <div>
            <div className="overline-label text-white/50 mb-4">Play Store Intelligence</div>
            <h1 className="font-heading font-black text-5xl leading-[1.05] max-w-md">
              Discover apps.<br />
              Score publishers.<br />
              <span className="text-blue-400">Close deals.</span>
            </h1>
            <p className="mt-6 text-white/60 max-w-md text-sm">
              Track newly launched Android apps, monitor rating movement, and surface
              high-potential publisher leads across Google Play markets.
            </p>
          </div>
          <div className="grid grid-cols-3 gap-6 border-t border-white/10 pt-6">
            {[["Markets", "9"], ["Categories", "26+"], ["Score", "0-100"]].map(([k, v]) => (
              <div key={k}>
                <div className="font-heading font-black text-3xl">{v}</div>
                <div className="overline-label text-white/50 mt-1">{k}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center p-8 bg-background">
        <form onSubmit={submit} className="w-full max-w-sm space-y-6" data-testid="login-form">
          <div>
            <div className="overline-label text-muted-foreground">Sign In</div>
            <h2 className="font-heading font-black text-3xl mt-1">Welcome back</h2>
            <p className="text-sm text-muted-foreground mt-2">Use your team credentials to continue.</p>
          </div>
          <div className="space-y-3">
            <div>
              <label className="text-xs font-medium block mb-1.5">Email</label>
              <input data-testid="login-email" type="email" required value={email}
                     onChange={(e) => setEmail(e.target.value)}
                     className="w-full border border-input bg-transparent px-3 py-2 text-sm rounded-sm focus:outline-none focus:ring-2 focus:ring-primary" />
            </div>
            <div>
              <label className="text-xs font-medium block mb-1.5">Password</label>
              <input data-testid="login-password" type="password" required value={password}
                     onChange={(e) => setPassword(e.target.value)}
                     className="w-full border border-input bg-transparent px-3 py-2 text-sm rounded-sm focus:outline-none focus:ring-2 focus:ring-primary" />
            </div>
          </div>
          {error && <div data-testid="login-error" className="text-xs text-red-600 border border-red-500/30 bg-red-500/10 px-3 py-2 rounded-sm">{error}</div>}
          <button data-testid="login-submit" disabled={loading} type="submit"
                  className="w-full bg-primary text-primary-foreground font-medium text-sm py-2.5 rounded-sm hover:opacity-90 transition-opacity">
            {loading ? "Signing in..." : "Sign in"}
          </button>
          <div className="text-[11px] text-muted-foreground text-center border-t border-border pt-4">
            
          </div>
        </form>
      </div>
    </div>
  );
}
